import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const PackagesPage = () => {
  return <SanityContentPage slug='packages' />
}

export default PackagesPage
